frontApp.popupMssage = {
  name: 'popupMssage',
  description: 'popupMssage',
  init() {
    /* eslint-disable */

    function getCookie(name) {
      const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    /* eslint-enable */

    setTimeout(() => {
      const popup = document.querySelectorAll('.popup-message');
      popup.forEach((el, index) => {
        const target = el.dataset.popup;
        const showTimes = Number(getCookie(`pop_${target}_show_times`));
        const showTimout = getCookie(`pop_${target}_show_timeout`);

        if (!showTimout && (!showTimes || (showTimes && showTimes <= 2))) {
          setTimeout(() => {
            el.classList.add('is-visible');
            const close = el.querySelector('.popup-message__close');
            close.addEventListener('click', () => {
              if (target) {
                document.cookie = `pop_${target}_show_times=${Number.isNaN(showTimes) ? 1 : showTimes + 1};max-age=31536000`;
                document.cookie = `pop_${target}_show_timeout=true;max-age=43200`;
              }
              el.classList.add('is-hide');
              el.classList.remove('is-visible');
            });
          }, 2000 * index);
        }
      });
    }, 3000);
  },
};
